import * as ko from "knockout";
import moment from "moment";

import {BlockUI} from "Core/Common/BlockUi";
import {Modal} from "Core/Common/Modal";
import {Notifier} from "Core/Common/Notifier";
import {LABELS} from "Core/Components/Translation/Locales";
import {FormatConverter} from 'FormatEditor/FormatConverter';
import {DATE_FORMATS} from "Core/Constants/DateTimeFormats";

import {AdministrationStore} from "../AdministrationStore";
import {ActiveSessionUserDto} from "./ActiveSessionUserDto";

import Template from "Pages/AdministrationPage/Tabs/ActiveSessionsPopup.html";

ko.templates["Pages/AdministrationPage/Tabs/ActiveSessionsPopup"] = Template;

export class ActiveSessionsPopup {
    private _users: KnockoutObservableArray<ActiveSessionUserDto>;
    private _modal: Modal;

    private _labels = LABELS;

    constructor(private _databaseId: number, private _apiClient: string) {
        this._users = ko.observableArray([]);
    }

    GetTemplateName(){
        return 'Pages/AdministrationPage/Tabs/ActiveSessionsPopup';
    }

    Show(){
        BlockUI.Block();

        AdministrationStore.GetActiveSessionUsers(this._databaseId, this._apiClient)
            .always(() => BlockUI.Unblock())
            .then(users => {
                this._users(users);
                this.ShowModal();
            })
            .fail(error => Notifier.Failed(error && error.message ? error.message : 'Failed to load active sessions'));
    }

    FormatDate(value: string){
        if(!value){
            return value;
        }
        return moment(FormatConverter.CorrectTimezone(value)).format(DATE_FORMATS.SAVE_FORMAT_FULL.MomentFormat);
    }

    private ShowModal(){
        this._modal = new Modal({
            minWidth: 400,
            addClass: 'active-sessions-modal'
        }, false);

        ko.cleanNode(this._modal.Wrapper);
        ko.applyBindings(this, this._modal.Wrapper);

        this._modal.Show();
    }
}
